module.exports = __webpack_public_path__ + "files/d8a629d21894b90448b5f42f457c2060.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/katex/dist/fonts/KaTeX_Main-Bold.woff
 ** module id = 1052
 ** module chunks = 0
 **/